import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Account } from '@zero/shared/util-models';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { AuthStateFacade } from '../../state/auth/auth-state.facade';

@Injectable({ providedIn: 'root' })
export class MoneyAccountInfrastructure {
  private readonly http = inject(HttpClient);
  private readonly authStateFacade = inject(AuthStateFacade);

  public getAccount(): Observable<Account> {
    return this.http.get<Account>(`${environment.apihost}/api/moneytransaction/account`, {
      params: { customerId: this.authStateFacade.customerId },
    });
  }
}
